const Footer = () => {
    return (
        <div>
            <p>All rights reserved @ 2022</p>
        </div>
    )
}

export default Footer;